import { render, staticRenderFns } from "./PoiCountryInfo.vue?vue&type=template&id=55ed2257&scoped=true&"
import script from "./PoiCountryInfo.vue?vue&type=script&lang=js&"
export * from "./PoiCountryInfo.vue?vue&type=script&lang=js&"
import style0 from "./PoiCountryInfo.vue?vue&type=style&index=0&id=55ed2257&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ed2257",
  null
  
)

export default component.exports